import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

export default function RewardConfirmation({
  modalIsOpen,
  closeModal,
  amount,
  group,
  handler,
  currency,
}) {
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className={'w-80'}>
        <div>
          <h3 className={'text-xl font-semibold'}>Gift rewards</h3>
        </div>
        <hr className={'my-2'} />
        <div className={'py-5'}>
          <p>
            Send {currency}
            {amount} airtime to {group.name}
          </p>
        </div>
        <div className={'p-2 w-auto'}>
          <button
            onClick={() =>
              handler(amount, group.id).then((res) => {
                closeModal();
                window.location.reload();
              })
            }
            className={
              ' mr-2 text-white bg-yellow-500 shadow px-3 py-2 text-sm rounded'
            }
          >
            Confirm
          </button>
          <button
            onClick={closeModal}
            className={
              'text-yellow-500 border border-yellow-500 shadow px-3 py-2 text-sm rounded'
            }
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
